$('.footer-block--menu h2.footer-block__heading').click(function() { 
    $(this).toggleClass("tab_active");
});
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

// $('.abz-logo-slider #gallery').slick({
//     slidesToShow:8,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 0,
//     speed: 8000,
//     pauseOnHover: true,
//     cssEase: 'linear',
//     arrows: false,
//     responsive: [    
//     {
//       breakpoint: 991,
//       settings: {
//         slidesToShow:4,
//         slidesToScroll: 1
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow:2,
//         slidesToScroll: 1
//       }
//     }
//     // You can unslick at a given breakpoint now by adding:
//     // settings: "unslick"
//     // instead of a settings object
//   ]
// });
$('.abz-signup-logo-slider #gallery').slick({
    slidesToShow:8,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 8000,
    pauseOnHover: true,
    cssEase: 'linear',
    arrows: false,
    responsive: [    
    {
      breakpoint: 991,
      settings: {
        slidesToShow:4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow:2,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
$('.abz-testimonials #abz-testimonial').slick({
    slidesToShow:3,
    slidesToScroll: 1,
    autoplay: false,
    pauseOnHover: true,
    arrows: true,
    variableWidth: true,
    speed: 2000,
    draggable: true,
    infinite: true,
    prevArrow:"<div class='slick-prev slick-arrow'><svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'><path d='M0.124913 10.6342C0.204173 10.8386 0.323018 11.0254 0.474627 11.1838L8.8011 19.5102C8.95637 19.6655 9.1407 19.7887 9.34357 19.8727C9.54644 19.9567 9.76387 20 9.98345 20C10.4269 20 10.8522 19.8238 11.1658 19.5103C11.3211 19.355 11.4443 19.1706 11.5283 18.9678C11.6123 18.7649 11.6556 18.5475 11.6556 18.3279C11.6556 17.8844 11.4794 17.4591 11.1658 17.1455L5.67034 11.6667L18.3099 11.6667C18.7516 11.6667 19.1752 11.4913 19.4875 11.179C19.7998 10.8667 19.9752 10.4431 19.9752 10.0014C19.9752 9.55976 19.7998 9.13618 19.4875 8.82388C19.1752 8.51158 18.7516 8.33613 18.3099 8.33613L5.67034 8.33613L11.1658 2.85731C11.3219 2.70249 11.4458 2.51831 11.5303 2.31538C11.6149 2.11245 11.6584 1.89479 11.6584 1.67495C11.6584 1.45511 11.6149 1.23745 11.5303 1.03451C11.4458 0.831584 11.3219 0.647403 11.1658 0.492591C11.011 0.336505 10.8268 0.212615 10.6239 0.12807C10.421 0.0435249 10.2033 -8.54289e-07 9.98346 -8.73508e-07C9.76362 -8.92727e-07 9.54595 0.0435248 9.34302 0.12807C9.14009 0.212615 8.95591 0.336505 8.8011 0.492591L0.474628 8.81906C0.323018 8.97744 0.204173 9.16419 0.124913 9.36861C-0.0416461 9.77404 -0.0416461 10.2288 0.124913 10.6342Z' fill='white'></path></svg></div>",
    nextArrow:"<div class='slick-next slick-arrow'><svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'><path d='M19.8503 9.36577C19.771 9.16135 19.6522 8.9746 19.5006 8.81622L11.1741 0.489749C11.0189 0.33448 10.8345 0.211313 10.6317 0.127282C10.4288 0.0432509 10.2113 0 9.99177 0C9.54829 0 9.12299 0.176168 8.80941 0.489749C8.65414 0.645019 8.53097 0.829351 8.44694 1.03222C8.36291 1.23509 8.31966 1.45252 8.31966 1.67211C8.31966 2.11558 8.49582 2.54089 8.80941 2.85447L14.3049 8.33329H1.66529C1.22363 8.33329 0.800057 8.50874 0.487754 8.82104C0.17545 9.13334 0 9.55692 0 9.99858C0 10.4402 0.17545 10.8638 0.487754 11.1761C0.800057 11.4884 1.22363 11.6639 1.66529 11.6639H14.3049L8.80941 17.1427C8.65332 17.2975 8.52943 17.4817 8.44489 17.6846C8.36034 17.8875 8.31682 18.1052 8.31682 18.3251C8.31682 18.5449 8.36034 18.7626 8.44489 18.9655C8.52943 19.1684 8.65332 19.3526 8.80941 19.5074C8.96422 19.6635 9.1484 19.7874 9.35133 19.8719C9.55426 19.9565 9.77193 20 9.99177 20C10.2116 20 10.4293 19.9565 10.6322 19.8719C10.8351 19.7874 11.0193 19.6635 11.1741 19.5074L19.5006 11.1809C19.6522 11.0226 19.771 10.8358 19.8503 10.6314C20.0169 10.226 20.0169 9.7712 19.8503 9.36577Z' fill='white'></path></svg></div>",
    responsive: [  
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow:1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
  
});
$('.abz-testimonials2 #abz-testimonial').slick({
  slidesToShow:1,
  slidesToScroll: 1,
  autoplay: false,
  pauseOnHover: true,
  arrows: false,
  speed: 500,
  draggable: true,
  dots: true,
  infinite: true  
  // You can unslick at a given breakpoint now by adding:
  // settings: "unslick"
  // instead of a settings object
});

if($(window).width() < 990) {
  $('.abz-header-binfo-inner').slick({
    slidesToShow:1,
    slidesToScroll: 1,
    autoplay: true,
    pauseOnHover: true,
    arrows: false,
    speed: 500,
    draggable: true,
    dots: false,
    autoplaySpeed: 5000,
    infinite: true  
  });
}
if($(window).width() < 768) {
  $('.announce-bar-lp-mob').slick({
    slidesToShow:1,
    slidesToScroll: 1,
    autoplay: true,
    pauseOnHover: true,
    arrows: false,
    speed: 500,
    draggable: true,
    dots: false,
    autoplaySpeed: 3000,
    infinite: true  
  });
}
$(window).resize(function() {
  if($(window).width() < 990) {
    if($('.abz-header-binfo-inner').hasClass('slick-initialized')) {
      $('.abz-header-binfo-inner').slick('unslick');
      $('.abz-header-binfo-inner').removeClass('slick-initialized');
      $('.abz-header-binfo-inner').slick({
        slidesToShow:1,
        slidesToScroll: 1,
        autoplay: true,
        pauseOnHover: true,
        arrows: false,
        speed: 500,
        draggable: true,
        dots: false,
        autoplaySpeed: 5000,
        infinite: true  
      });
    } else {
      $('.abz-header-binfo-inner').slick({
        slidesToShow:1,
        slidesToScroll: 1,
        autoplay: true,
        pauseOnHover: true,
        arrows: false,
        speed: 500,
        draggable: true,
        dots: false,
        autoplaySpeed: 5000,
        infinite: true  
      });
    }
  } else {
    if($('.abz-header-binfo-inner').hasClass('slick-initialized')) {
      $('.abz-header-binfo-inner').slick('unslick');
      $('.abz-header-binfo-inner').removeClass('slick-initialized');
    }
  }
});


$('.abz-signup-testimonial #abz-testimonial').slick({
    dots:true,
    slidesToShow:1,
    slidesToScroll: 1,
    autoplay: true,
    pauseOnHover: true,
    arrows: false,
    //variableWidth: true,
    speed: 2000,
    draggable: true,
    infinite: true,
    responsive: [  
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow:1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
  
});

$('.lp-benefits-slider').slick({
      speed: 10000,
      autoplay: true,
      autoplaySpeed: 0,
      centerMode: true,
      cssEase: 'linear',
      slidesToShow: 6,
      slidesToScroll: 1,
      variableWidth: true,
      infinite: true,
      initialSlide: 1,
      arrows: false,
      buttons: false,
       responsive: [
          {
            breakpoint: 767,
            settings: {
              speed: 5000,
              autoplay: true,
              autoplaySpeed: 0,
              centerMode: true,
              cssEase: 'linear',
              slidesToShow: 2,
              slidesToScroll: 1,
              variableWidth: true,
              infinite: true,
              initialSlide: 1,
              arrows: false,
              buttons: false
            }
          }
      ]
});

$('.lp-trust-icons-slider').slick({
      speed: 10000,
      autoplay: true,
      autoplaySpeed: 0,
      centerMode: true,
      cssEase: 'linear',
      slidesToShow: 6,
      slidesToScroll: 1,
      variableWidth: true,
      infinite: true,
      initialSlide: 1,
      arrows: false,
      buttons: false,
       responsive: [
          {
            breakpoint: 9999,
            settings: "unslick"
          },
          {
            breakpoint: 767,
            settings: {
              speed: 5000,
              autoplay: true,
              autoplaySpeed: 0,
              centerMode: true,
              cssEase: 'linear',
              slidesToShow: 2,
              slidesToScroll: 1,
              variableWidth: true,
              infinite: true,
              initialSlide: 1,
              arrows: false,
              buttons: false
            }
          }
      ]
});

var backButton = '<img alt="Previous Arrow" src="https://cdn.shopify.com/s/files/1/0779/1709/4081/files/left-arr-tp.svg?v=1729152577" class="slick-prev">';
var nextButton = '<img alt="Next Arrow" src="https://cdn.shopify.com/s/files/1/0779/1709/4081/files/left-arr-tp.svg?v=1729152577" class="slick-next">'

$('.lp-tp-reviews-slider').slick({
      speed: 8000,
      autoplay: true,
      centerMode: true,
      centerPadding: '50px',
      cssEase: 'linear',
      slidesToShow: 3,
      slidesToScroll: 1,
      variableWidth: false,
      infinite: true,
      arrows: false,
      buttons: false,
       responsive: [
          {
            breakpoint: 767,
            settings: {
              speed: 1000,
              autoplay: false,
              centerMode: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              variableWidth: false,
              infinite: true,
              arrows: true,
              prevArrow: backButton,
              nextArrow: nextButton,
              dots: true
            }
          }
      ]
});

$('.potential-cols-slider').slick({
    slidesToShow:1.75,
    slidesToScroll: 1,
    autoplay: false,
    pauseOnHover: true,
    variableWidth: false,
    speed: 2000,
    draggable: true,
    infinite: false,
    arrows: true,
    dots: true,
    prevArrow: backButton,
    nextArrow: nextButton,
    responsive: [  
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: .55,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
  
});

$('.lp-features-cont-slider').slick({
      speed: 10000,
      autoplay: true,
      autoplaySpeed: 0,
      centerMode: true,
      cssEase: 'linear',
      slidesToShow: 4,
      slidesToScroll: 1,
      variableWidth: true,
      infinite: true,
      initialSlide: 1,
      arrows: false,
      buttons: false,
       responsive: [
          {
            breakpoint: 767,
            settings: {
              speed: 5000,
              autoplay: true,
              autoplaySpeed: 0,
              centerMode: true,
              cssEase: 'linear',
              slidesToShow: 2,
              slidesToScroll: 1,
              variableWidth: true,
              infinite: true,
              initialSlide: 1,
              arrows: false,
              buttons: false
            }
          }
      ]
});